import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  CourseRepProgress,
  PracticeCourseDetail,
  PracticeCourseFilters,
  PracticeCourseAggregateFreshness,
  PracticeCourseQuery,
  PracticeCourseSummary,
  RepCourseDetail,
} from '../models/practice-course.types';

@Injectable({ providedIn: 'root' })
export class PracticeCoursesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/backoffice/practice-courses`;

  getFilters(search?: string) {
    const params = search?.trim() ? new HttpParams().set('search', search.trim()) : undefined;
    return this.http.get<PracticeCourseFilters>(`${this.baseUrl}/filters`, { params });
  }

  getCourses(query: PracticeCourseQuery) {
    return this.http.get<{
      data: PracticeCourseSummary[];
      total: number;
      freshness: PracticeCourseAggregateFreshness;
    }>(this.baseUrl, {
      params: this.params(query),
    });
  }

  getCourse(courseVersionId: string) {
    return this.http.get<PracticeCourseDetail>(`${this.baseUrl}/${courseVersionId}`);
  }

  getProgress(courseVersionId: string, query: PracticeCourseQuery) {
    return this.http.get<{
      data: CourseRepProgress[];
      total: number;
      freshness: PracticeCourseAggregateFreshness;
    }>(`${this.baseUrl}/${courseVersionId}/progress`, { params: this.params(query) });
  }

  getRep(courseVersionId: string, userId: number) {
    return this.http.get<RepCourseDetail>(`${this.baseUrl}/${courseVersionId}/reps/${userId}`);
  }

  private params(query: PracticeCourseQuery) {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(query)) {
      if (value === undefined || value === null || value === '') continue;
      params = params.set(key, value instanceof Date ? value.toISOString() : String(value));
    }
    return params;
  }
}
